export function isAnchor(props) {
  return props.href !== undefined;
}
export function isLink(props) {
  return props.href !== undefined || props.to !== undefined;
}